import api from './api';

export interface ProjectMediaItem {
  _id: string;
  id: string;
  name: string;
  type: 'video' | 'audio' | 'image';
  status: string;
  url?: string;
  projectId?: string;
  projectName?: string;
  createdAt: string;
  updatedAt: string;
  // Only set for 'video' items — the VideoTranslationJob's own jobId (not its Mongo _id above).
  jobId?: string;
}

export interface ProjectMediaResponse {
  success: boolean;
  data: {
    items: ProjectMediaItem[];
    pagination: {
      total: number;
      limit: number;
      offset: number;
      hasMore: boolean;
    };
  };
}

export type ProjectMediaType = 'videos' | 'audio' | 'images' | 'all';

export const projectMediaApi = {
  getMedia: async (
    type: ProjectMediaType = 'all',
    params?: { projectId?: string; search?: string; limit?: number; offset?: number }
  ): Promise<ProjectMediaResponse> => {
    const response = await api.get('/project-media', {
      params: { type, ...params },
    });
    return response.data;
  },

  shareMedia: async ({
    itemId,
    targetProjectId,
    itemType,
    name,
  }: {
    itemId: string;
    targetProjectId: string;
    itemType: 'video' | 'audio' | 'image' | 'voice' | 'translation' | 'avatar';
    name: string;
  }): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/project-media/${itemId}/share`, {
      targetProjectId,
      itemType,
      name,
    });
    return response.data;
  },
};
